import React, { useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import ModalAbout from "./ModalAbout"
import ModalFeedback from "./ModalFeedback"
import ModalFeedbackSuccess from "./ModalFeedbackSuccess"
import ModalFeedbackPersonal from "./ModalFeedbackPersonal"
import ModalSettings from "./ModalSettings"
import ModalSettingsSuccess from "./ModalSettingsSuccess"
import ModalLogin from "./ModalLogin"
import ModalRegistration from "./ModalRegistration"
import ModalRegistrationSuccess from "./ModalRegistrationSuccess"
import ModalError from "./ModalError"
import ModalSendAnnounces from "./ModalSendAnnounces"
import ModalSendAnnouncesSuccess from "./ModalSendAnnouncesSuccess"
import ModalSessionActive from "./ModalSessionActive"
import { ModalContext } from "../../context"

function Windows() {
	const { modal, closeModal, toggleModal } = useContext(ModalContext)

	return(
		<>
			<ModalAbout
				isOpen={modal.about}
				closeModal={closeModal}
			/>
			<ModalFeedback
				isOpen={modal.feedback}
				closeModal={closeModal}
			/>
			<ModalFeedbackSuccess
				isOpen={modal.feedbackSuccess}
				closeModal={closeModal}
			/>
			<ModalFeedbackPersonal
				isOpen={modal.feedbackPersonal}
				closeModal={closeModal}
			/>
			<ModalSettings
				isOpen={modal.settings}
				closeModal={closeModal}
			/>
			<ModalSettingsSuccess
				isOpen={modal.settingsSuccess}
				closeModal={closeModal}
			/>
			<ModalLogin
				isOpen={modal.login}
				closeModal={closeModal}
			/>
			<ModalRegistration
				isOpen={modal.registration}
				closeModal={closeModal}
			/>
			<ModalRegistrationSuccess
				isOpen={modal.registrationSuccess}
				closeModal={closeModal}
			/>
			<ModalError
				isOpen={modal.error}
				closeModal={closeModal}
			/>
			<ModalSendAnnounces
				isOpen={modal.sendAnnounces}
				closeModal={closeModal}
			/>
			<ModalSendAnnouncesSuccess
				isOpen={modal.sendAnnouncesSuccess}
				closeModal={closeModal}
			/>
			<ModalSessionActive
				isOpen={modal.sessionActive}
				params={modal.params}
				closeModal={closeModal}
				toggleModal={toggleModal}
			/>
		</>
	)
}

export default Windows